import React from 'react';

import { WidgetItemType } from './Dashboard.types';
import DashboardWidgetBarChartGroup from './widgets/DashboardWidgetBarChartGroup';
import DashboardWidgetLineChart from './widgets/DashboardWidgetLineChart';
import DashboardWidgetProgress from './widgets/DashboardWidgetProgress';
import DashboardWidgetProgressHalf from './widgets/DashboardWidgetProgressHalf';
export type WidgetComponentProps =
 | { widgetContent: WidgetItemType[]; totalSum: number }
 | Record<string, never>;

export interface WidgetTypeConfig {
 name: string;
 component: React.ComponentType<WidgetComponentProps>;
 requiresData?: boolean;
}

const widgetTypes: WidgetTypeConfig[] = [
 {
  name: 'driversProgress',
  component:
   DashboardWidgetProgress as React.ComponentType<WidgetComponentProps>,
  requiresData: true,
 },
 {
  name: 'destPointNeto',
  component:
   DashboardWidgetBarChartGroup as React.ComponentType<WidgetComponentProps>,
  requiresData: true,
 },
 {
  name: 'InOutProduct',
  component:
   DashboardWidgetLineChart as React.ComponentType<WidgetComponentProps>,
  requiresData: true,
 },
 {
  name: 'ProductStock',
  component:
   DashboardWidgetProgressHalf as React.ComponentType<WidgetComponentProps>,
  requiresData: true,
 },
];

export const getWidgetType = (name: string): WidgetTypeConfig | undefined =>
 widgetTypes.find((type) => type.name === name);

export default widgetTypes;

